var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5257 0.710843C12.4203 0.519114 12.2188 0.399994 12 0.399994C11.7812 0.399994 11.5797 0.519114 11.4743 0.710843L0.474264 20.7108C0.372032 20.8967 0.375551 21.1228 0.48352 21.3054C0.591489 21.488 0.787858 21.6 0.999994 21.6H23C23.2121 21.6 23.4085 21.488 23.5165 21.3054C23.6244 21.1228 23.628 20.8967 23.5257 20.7108L12.5257 0.710843ZM12.5453 8.5V15.5H11.4555V8.5H12.5453ZM11.5141 17.8184C11.4047 17.6973 11.35 17.5469 11.35 17.3672C11.35 17.1797 11.4047 17.0234 11.5141 16.8984C11.6273 16.7734 11.7953 16.7109 12.018 16.7109C12.2406 16.7109 12.4086 16.7734 12.5219 16.8984C12.6391 17.0234 12.6976 17.1797 12.6976 17.3672C12.6976 17.5469 12.6391 17.6973 12.5219 17.8184C12.4086 17.9395 12.2406 18 12.018 18C11.7953 18 11.6273 17.9395 11.5141 17.8184Z",
    fill: "#ED8B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.19a01675edb74bca4e4ffa267c99e9fe.svg";
export { ForwardRef as ReactComponent };